import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "/api",
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

// リクエストインターセプター
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// レスポンスインターセプター
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // ローカルストレージのトークンを削除
      localStorage.removeItem("token");
      // ログインページへリダイレクト
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

// ユーザー関連API
export const userAPI = {
  // ユーザー一覧取得
  getUsers: (params = {}) => api.get("/users", { params }),
  // ユーザー詳細取得
  getUser: (id) => api.get(`/users/${id}`),
  // ユーザー作成
  createUser: (userData) => api.post("/users", userData),
  // ユーザー更新
  updateUser: (id, userData) => api.put(`/users/${id}`, userData),
  // ユーザーパスワード更新
  updateUserPassword: (id, passwordData) =>
    api.put(`/users/${id}/password`, passwordData),
  // ユーザー削除
  deleteUser: (id) => api.delete(`/users/${id}`),
};

// アプリケーション関連API
export const appAPI = {
  // アプリ一覧取得
  getApps: (params = {}) => api.get("/apps", { params }),
  // アプリ詳細取得
  getApp: (id) => api.get(`/apps/${id}`),
  // アプリ作成
  createApp: (appData) => api.post("/apps", appData),
  // アプリ更新
  updateApp: (id, appData) => api.put(`/apps/${id}`, appData),
  // クライアントシークレット再生成
  regenerateSecret: (id) => api.post(`/apps/${id}/regenerate-secret`),
  // アプリ削除
  deleteApp: (id) => api.delete(`/apps/${id}`),
};

// mailcow（WebMail）メールユーザー管理
const MAILCOW_TIMEOUT = 25000;

export const mailcowAPI = {
  getDomains: () => api.get("/mailcow/domains", { timeout: MAILCOW_TIMEOUT }),
  getMailboxes: (params = {}) =>
    api.get("/mailcow/mailboxes", { params, timeout: MAILCOW_TIMEOUT }),
  createMailbox: (data) =>
    api.post("/mailcow/mailboxes", data, { timeout: MAILCOW_TIMEOUT }),
  updateMailbox: (email, data) =>
    api.put(`/mailcow/mailboxes/${encodeURIComponent(email)}`, data, {
      timeout: MAILCOW_TIMEOUT,
    }),
  deleteMailbox: (email) =>
    api.delete(`/mailcow/mailboxes/${encodeURIComponent(email)}`, {
      timeout: MAILCOW_TIMEOUT,
    }),
};

// 認証関連API
export const authAPI = {
  // 現在のユーザー情報取得
  getMe: () => api.get("/auth/me"),
  // プロフィール更新
  updateProfile: (profileData) => api.put("/auth/profile", profileData),
  // パスワード変更
  changePassword: (passwordData) => api.put("/auth/password", passwordData),
};

// 権限関連API
export const permissionAPI = {
  // ユーザーのアプリ権限取得
  getUserPermissions: (userId) => api.get(`/sso/permissions/${userId}`),
  // ユーザーにアプリ権限付与
  grantPermission: (user_id, app_id, permissions) =>
    api.post("/sso/permissions", { user_id, app_id, permissions }),
  // ユーザーのアプリ権限取り消し
  revokePermission: (userId, appId) =>
    api.delete(`/sso/permissions/${userId}/${appId}`),
};

export default api;
